import { memo } from 'react';
import styles from './Advt.module.css';
import { useGetParams } from '../../hooks/useGetParams';
import { motion } from 'framer-motion';

import posterDefault from '../../assets/images/bgPoster.webp';
import bgDefaultVideo from '../../assets/video/bgVideo.webm';

const Advt = memo(() => {
  const { title, qrCode1, qrCode2, paddingQR, sizeQR, titleFontSize } =
    useGetParams();

  return (
    <div className={styles.wrapper}>
      {title && (
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: [0, 1.3, 1] }}
          transition={{
            duration: 0.8,
            delay: 0.56,
            times: [0, 0.75, 1],
            ease: ['easeOut', 'easeOut'],
          }}
          className={styles.title}
          style={{ fontSize: `${titleFontSize}rem` }}
        >
          <div className={styles.wiggle}>{title}</div>
        </motion.div>
      )}

      <div className={styles.qrsWrapper}>
        {qrCode1 && (
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{
              scale: { duration: 1.36, delay: 0.44 },
            }}
            className={styles.qrCode}
            style={{
              padding: `${paddingQR}rem`,
              background: paddingQR === '0' && 'none',
              width: `${sizeQR}rem`,
              height: `${sizeQR}rem`,
            }}
          >
            <img src={qrCode1} alt="qrCode1" />
          </motion.div>
        )}
        {qrCode2 && (
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{
              scale: { duration: 1.36, delay: 0.44 },
            }}
            className={styles.qrCode}
            style={{
              padding: `${paddingQR}rem`,
              background: paddingQR === '0' && 'none',
              width: `${sizeQR}rem`,
              height: `${sizeQR}rem`,
            }}
          >
            <img src={qrCode2} alt="qrCode2" />
          </motion.div>
        )}
      </div>

      <video
        autoPlay="autoplay"
        muted="muted"
        loop
        className={styles.bgVideo}
        poster={posterDefault}
      >
        <source src={bgDefaultVideo} type="video/webm" />
      </video>
    </div>
  );
});

export default Advt;
